import FaqActionTypes from "./faq.types";

export const fetchFaqsStart = () => ({
  type: FaqActionTypes.FETCH_FAQS_START
});

export const fetchFaqsSuccess = faqItems => ({
  type: FaqActionTypes.FETCH_FAQS_SUCCESS,
  payload: faqItems
});

export const fetchFaqsFailure = errorMessage => ({
  type: FaqActionTypes.FETCH_FAQS_FAILURE,
  payload: errorMessage
});
